module.exports = __webpack_public_path__ + "static/img/15bg_7.458b206.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/15bg_7.png
// module id = 656
// module chunks = 1